module.exports = __webpack_public_path__ + "static/node-bb2242cf01863c69fd411b7c47e956a9.png";